import { isFlagEnabled } from "js/utilities";
import { default as ReleasingPolicies } from "./policies";
import DeprecatedPolicies from "./DeprecatedPolicies";

export default function policies() {
  return isFlagEnabled("ENABLE_SERVICE_TRACKING") ? (
    <ReleasingPolicies />
  ) : (
    <DeprecatedPolicies />
  );
}
